module.exports = __webpack_public_path__ + "media/draw.4875e1fd.wav";